import { useEffect, useState } from "react";
import { Box, BoxProps } from "@mui/material"
import { useTranslation } from "react-i18next";
import Image from 'next/image';

import { WaitingPaymentContainer } from "./style";
import { SOCKET } from "@/hooks/useWebSocket";
import { PaymentStatus, SOCKET_CONFIG } from "@/types/consistency";
import { useRouter } from "next/router";
import { pushToBookingDetail } from "@/utils/utils";

interface IPaymentStatusDisplay {
  src: string;
  alt: string;
  message: string;
}

const PAYMENT_STATUS_SUCCESS: IPaymentStatusDisplay = {
  src: '/assets/images/success.png',
  alt: 'payment_success',
  message: 'finishBookingNow',
};

const PAYMENT_STATUS_ERROR: IPaymentStatusDisplay = {
  src: '/assets/icons/error.svg',
  alt: 'payment_error',
  message: 'paymentFailed',
};

const PAYMENT_STATUS_WAITING: IPaymentStatusDisplay = {
  src: '/assets/images/logo.jpg',
  alt: 'loading',
  message: 'waitingPayment',
};


interface WaitingPaymentProps extends BoxProps {
  codeTracking: string;
  orderId: string;
}

const WaitingPayment: React.FC<WaitingPaymentProps> = ({ orderId, codeTracking, ...props }) => {

  const router = useRouter();
  const { t } = useTranslation(['common']);

  const [paymentStatusDisplay, setPaymentStatusDisplay] = useState<IPaymentStatusDisplay>(PAYMENT_STATUS_WAITING);
  const [paymentStatus, setPaymentStatus] = useState<number>(-1);


  useEffect(() => {
    SOCKET.on(SOCKET_CONFIG.PAYMENT_CUSTOMER_ORDER, (dataPayment) => {

      console.group('Waiting payment -> PAYMENT_CUSTOMER_ORDER');
      console.log('socket dataPayment: ', dataPayment);
      console.log('waiting data: ', { waiting_tour_id: orderId });
      console.groupEnd();

      if (paymentStatus !== -1) {
        console.log('Payment status already update status -> ', paymentStatus);
        return;
      }

      if (dataPayment && dataPayment.id === orderId) {

        console.group('Waiting payment -> PAYMENT_CUSTOMER_ORDER -> dataPayment same');
        console.log('dataPayment.paymentStatus: ', dataPayment.paymentStatus);
        console.groupEnd();

        if (dataPayment.paymentStatus === PaymentStatus.Paid.code) {

          console.log('PAYMENT_CUSTOMER_ORDER -> Payment successful');
          setPaymentStatusDisplay(PAYMENT_STATUS_SUCCESS);
          setPaymentStatus(1);

          setTimeout(() => {
            pushToBookingDetail(router, codeTracking);
          }, 500);
        }
        else if (dataPayment.paymentStatus === PaymentStatus.NonPaid.code) {
          console.log('PAYMENT_CUSTOMER_ORDER -> Payment failed');
          setPaymentStatusDisplay(PAYMENT_STATUS_ERROR);
          setPaymentStatus(0);
        }

        SOCKET.emit(SOCKET_CONFIG.PAYMENT_CUSTOMER_ORDER, {
          isEmbedWaitingOrder: true,
          embedCodeTracking: codeTracking,
        });

      }
    });

    return () => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Waiting payment socket off');
        return;
      }
      SOCKET.off(SOCKET_CONFIG.PAYMENT_CUSTOMER_ORDER);
    };
  }, [codeTracking, router, orderId]);


  return (
    <WaitingPaymentContainer {...props}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{ width: 80, height: 80, borderRadius: '50%' }}
          component="img"
          src={paymentStatusDisplay.src}
          alt={paymentStatusDisplay.alt}
        />
      </Box>
      <Box
        sx={{ typography: 'h6', textAlign: 'center', paddingBlock: 2 }}
      >
        {t(paymentStatusDisplay.message)}
      </Box>
    </WaitingPaymentContainer>
  )
}

export default WaitingPayment;